export default __webpack_public_path__ + "static/media/sad.d9daa67e.jpg";